
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12 12","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.5 9.5v-2h2c.825 0 1.5-.675 1.5-1.5s-.675-1.5-1.5-1.5h-2v-2C7.5 1.675 6.825 1 6 1s-1.5.675-1.5 1.5v2h-2C1.675 4.5 1 5.175 1 6s.675 1.5 1.5 1.5h2v2c0 .825.675 1.5 1.5 1.5s1.5-.675 1.5-1.5z"}})])
          )
        }
      }
    